import {
    PersonalContributionSchedule,
    PersonalContributionScheduleStatus,
    PersonalContributionScheduleType
} from "@/shared/types";
import moment from "moment/moment";

export function isScheduleCancelledOrCompleted (schedule: PersonalContributionSchedule): boolean {
    return isScheduleCancelled(schedule) || isScheduleCompleted(schedule);
}

export function isScheduleCancelled (schedule: PersonalContributionSchedule): boolean {
    return schedule.status === PersonalContributionScheduleStatus.Cancelled;
}

export function isScheduleCompleted (schedule: PersonalContributionSchedule): boolean {
    // Schedule end date has passed - this schedule is expired
    return (schedule.scheduleEndDate && moment().startOf("day") >
            moment(schedule.scheduleEndDate)) ||
        // This one-time schedule has been processed already
        (schedule.scheduleType === PersonalContributionScheduleType.OneTime &&
            moment().startOf("day") > moment(schedule.scheduleStartDate));
}